import AnswerCard from "@components/services/AnswerCard";
import type { BriefingContent } from "../types";

interface BriefingIntroProps {
  data: BriefingContent;
}

export default function BriefingIntro({ data }: BriefingIntroProps) {
  return (
    <div className="mb-16">
      <div id="kurzantwort" className="mb-12">
        <AnswerCard question={data.kurzantwort.question} paragraphs={data.kurzantwort.paragraphs} />
      </div>

      <div id="guide" className="max-w-3xl">
        <h2 className="text-2xl font-bold text-abis-primary mb-4">{data.guide.title}</h2>
        <div className="space-y-3 text-[15px] text-gray-700 leading-relaxed">
          {data.guide.paragraphs.map((paragraph, i) => (
            <p key={i} dangerouslySetInnerHTML={{ __html: markdownBoldToHtml(paragraph) }} />
          ))}
        </div>
        <p className="text-sm text-gray-500 mt-4">{data.overview.lede}</p>
      </div>
    </div>
  );
}

function markdownBoldToHtml(text: string): string {
  return text.replace(/\*\*(.+?)\*\*/g, "<strong>$1</strong>");
}
